Drupal.behaviors.accordionMA = {
  attach: function registerAccordionEvents(context, settings) {
	  window.maAccordions.registerAccordionEvents();
	}
};


window.flipCards = {
  cards: [],
  countCards: function() {
    var cardCount = 0;
    for (let flipCard of document.querySelectorAll('.flip-card')) {
      this.cards.push(flipCard);
      flipCard.setAttribute("data-card-number", cardCount);
      cardCount++;
    }
    window.flipCards.highestCard = cardCount;
  },
  preventFlip: function(e) {
    //console.log("link clicked");
    e.stopImmediatePropagation();
    e.preventDefault();
    const href = e.target.href;
    window.location = href;
    return false;
  },

  followCardLink: function(card) {
    const anchor = card.querySelector('.flip-card__link');
    window.location = anchor.href;
  },

  registerEvents: function() {
    window.flipCards.countCards();
    // Prevent click/touch actions on flip-card links from bubbling.
    for (let link of document.querySelectorAll('.flip-card__link')) {
      link.addEventListener("click", window.flipCards.preventFlip);
      link.addEventListener("touchend", window.flipCards.preventFlip);
    }

    // Manage card flipped state.
    for (let flipCard of document.querySelectorAll('.flip-card')) {
      flipCard.addEventListener('click', function(e) {
        e.preventDefault();
        //window.flipCards.followCardLink(this);
        if (this.classList.contains('flipped')) {
          this.classList.remove('flipped');
          this.blur();
        } else {
          this.classList.add('flipped');
        }
      });
      flipCard.addEventListener('mouseover', function() {
        if (!this.classList.contains('mouseOverFlipped')) {
          this.classList.add('mouseOverFlipped');
        }
      });
      flipCard.addEventListener('mouseout', function() {
        if (this.classList.contains('mouseOverFlipped')) {
          this.classList.remove('mouseOverFlipped');
        }
      });
      flipCard.addEventListener('keydown', function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          //window.flipCards.followCardLink(this);
          if (this.classList.contains('flipped')) {
            this.classList.remove('flipped');
            this.blur();
            var cardNumber = this.getAttribute('data-card-number');
            // set focus to next card, or first card if @ max card
            window.flipCards.cards[(++cardNumber%window.flipCards.highestCard)].focus();
          } else {
            this.classList.add('flipped');
          }
        }
      })
    }
  }
}

if (document.readyState === 'loading') {  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', window.flipCards.registerEvents);
} else {  // `DOMContentLoaded` has already fired
  window.flipCards.registerEvents()
}


/*
Details Element Polyfill 2.4.0
Copyright © 2019 Javan Makhmali
 */
(function() {
  "use strict";
  var element = document.createElement("details");
  var elementIsNative = typeof HTMLDetailsElement != "undefined" && element instanceof HTMLDetailsElement;
  var support = {
    open: "open" in element || elementIsNative,
    toggle: "ontoggle" in element
  };
  var styles = '\ndetails, summary {\n  display: block;\n}\ndetails:not([open]) > *:not(summary) {\n  display: none;\n}\nsummary::before {\n  content: "►";\n  padding-right: 0.3rem;\n  font-size: 0.6rem;\n  cursor: default;\n}\n[open] > summary::before {\n  content: "▼";\n}\n';
  var _ref = [], forEach = _ref.forEach, slice = _ref.slice;
  if (!support.open) {
    polyfillStyles();
    polyfillProperties();
    polyfillToggle();
    polyfillAccessibility();
  }
  if (support.open && !support.toggle) {
    polyfillToggleEvent();
  }
  function polyfillStyles() {
    document.head.insertAdjacentHTML("afterbegin", "<style>" + styles + "</style>");
  }
  function polyfillProperties() {
    var prototype = document.createElement("details").constructor.prototype;
    var setAttribute = prototype.setAttribute, removeAttribute = prototype.removeAttribute;
    var open = Object.getOwnPropertyDescriptor(prototype, "open");
    Object.defineProperties(prototype, {
      open: {
        get: function get() {
          if (this.tagName == "DETAILS") {
            return this.hasAttribute("open");
          } else {
            if (open && open.get) {
              return open.get.call(this);
            }
          }
        },
        set: function set(value) {
          if (this.tagName == "DETAILS") {
            return value ? this.setAttribute("open", "") : this.removeAttribute("open");
          } else {
            if (open && open.set) {
              return open.set.call(this, value);
            }
          }
        }
      },
      setAttribute: {
        value: function value(name, _value) {
          var _this = this;
          var call = function call() {
            return setAttribute.call(_this, name, _value);
          };
          if (name == "open" && this.tagName == "DETAILS") {
            var wasOpen = this.hasAttribute("open");
            var result = call();
            if (!wasOpen) {
              var summary = this.querySelector("summary");
              if (summary) summary.setAttribute("aria-expanded", true);
              triggerToggle(this);
            }
            return result;
          }
          return call();
        }
      },
      removeAttribute: {
        value: function value(name) {
          var _this2 = this;
          var call = function call() {
            return removeAttribute.call(_this2, name);
          };
          if (name == "open" && this.tagName == "DETAILS") {
            var wasOpen = this.hasAttribute("open");
            var result = call();
            if (wasOpen) {
              var summary = this.querySelector("summary");
              if (summary) summary.setAttribute("aria-expanded", false);
              triggerToggle(this);
            }
            return result;
          }
          return call();
        }
      }
    });
  }
  function polyfillToggle() {
    onTogglingTrigger(function(element) {
      element.hasAttribute("open") ? element.removeAttribute("open") : element.setAttribute("open", "");
    });
  }
  function polyfillToggleEvent() {
    if (window.MutationObserver) {
      new MutationObserver(function(mutations) {
        forEach.call(mutations, function(mutation) {
          var target = mutation.target, attributeName = mutation.attributeName;
          if (target.tagName == "DETAILS" && attributeName == "open") {
            triggerToggle(target);
          }
        });
      }).observe(document.documentElement, {
        attributes: true,
        subtree: true
      });
    } else {
      onTogglingTrigger(function(element) {
        var wasOpen = element.getAttribute("open");
        setTimeout(function() {
          var isOpen = element.getAttribute("open");
          if (wasOpen != isOpen) {
            triggerToggle(element);
          }
        }, 1);
      });
    }
  }
  function polyfillAccessibility() {
    setAccessibilityAttributes(document);
    if (window.MutationObserver) {
      new MutationObserver(function(mutations) {
        forEach.call(mutations, function(mutation) {
          forEach.call(mutation.addedNodes, setAccessibilityAttributes);
        });
      }).observe(document.documentElement, {
        subtree: true,
        childList: true
      });
    } else {
      document.addEventListener("DOMNodeInserted", function(event) {
        setAccessibilityAttributes(event.target);
      });
    }
  }
  function setAccessibilityAttributes(root) {
    findElementsWithTagName(root, "SUMMARY").forEach(function(summary) {
      var details = findClosestElementWithTagName(summary, "DETAILS");
      summary.setAttribute("aria-expanded", details.hasAttribute("open"));
      if (!summary.hasAttribute("tabindex")) summary.setAttribute("tabindex", "0");
      if (!summary.hasAttribute("role")) summary.setAttribute("role", "button");
    });
  }
  function eventIsSignificant(event) {
    return !(event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.target.isContentEditable);
  }
  function onTogglingTrigger(callback) {
    addEventListener("click", function(event) {
      if (eventIsSignificant(event)) {
        if (event.which <= 1) {
          var element = findClosestElementWithTagName(event.target, "SUMMARY");
          if (element && element.parentNode && element.parentNode.tagName == "DETAILS") {
            callback(element.parentNode);
          }
        }
      }
    }, false);
    addEventListener("keydown", function(event) {
      if (eventIsSignificant(event)) {
        if (event.keyCode == 13 || event.keyCode == 32) {
          var element = findClosestElementWithTagName(event.target, "SUMMARY");
          if (element && element.parentNode && element.parentNode.tagName == "DETAILS") {
            callback(element.parentNode);
            event.preventDefault();
          }
        }
      }
    }, false);
  }
  function triggerToggle(element) {
    var event = document.createEvent("Event");
    event.initEvent("toggle", false, false);
    element.dispatchEvent(event);
  }
  function findElementsWithTagName(root, tagName) {
    return (root.tagName == tagName ? [ root ] : []).concat(typeof root.getElementsByTagName == "function" ? slice.call(root.getElementsByTagName(tagName)) : []);
  }
  function findClosestElementWithTagName(element, tagName) {
    if (typeof element.closest == "function") {
      return element.closest(tagName);
    } else {
      while (element) {
        if (element.tagName == tagName) {
          return element;
        } else {
          element = element.parentNode;
        }
      }
    }
  }
})();


window.maAccordions = {
  isMouseDown: false,
	eventsRegister: false,
  ifClassMissingThenAdd: function(ele, classStrArr) {
    for (let classStr of classStrArr) {
      if (!ele.classList.contains(classStr)) {
        ele.classList.add(classStr);
      }
    }
  },
	registerAccordionEvents: function() {
		if (!this.eventsRegister) {
			this.eventsRegister = true;
			// initial set up
			for (let accordionContent of document.querySelectorAll('.js-accordion-details')) {
				window.maAccordions.ifClassMissingThenAdd(accordionContent.querySelector('.degree-program__accordion.views-row'), [
          "ui-accordion-content", "ui-corner-bottom","ui-helper-reset",
          "ui-widget-content", "ui-accordion-content-active"]);
      }
			for (let accordion of document.querySelectorAll('.js-accordion-details')) {
				if (accordion.open) {
          accordion.setAttribute('aria-expanded', "true");
				} else {
          accordion.setAttribute('aria-expanded', "false");
				}
			}

      if (document.querySelector('.degree-program--list-view')) {
  			document.querySelector('.degree-program--list-view')
  				.addEventListener('click', window.maAccordions.refreshAccordions);
  			document.addEventListener('keydown', (event) => {
  			  const keyName = event.key;
  			  if (keyName === ' ' || keyName === 'Enter') {
  					window.maAccordions.refreshAccordions();
  			  }
  			});
      }
    }
	},
	refreshAccordions: function() {
		// click and key events fire before accordion open
		window.setTimeout(function() {
			for (let accordion of document.querySelectorAll('.js-accordion-details')) {
				let accordionDetails = accordion.querySelector('.ui-accordion-content');
				let accordionSummary = accordion.querySelector('summary');
				if (!accordion.open) {
					// change icon
					// open content
          accordion.setAttribute('aria-expanded', "false");
					accordionDetails.setAttribute('aria-hidden', "true");
					if (accordionSummary.classList.contains('ui-accordion-header-active')) {
						accordionSummary.classList.remove('ui-accordion-header-active');
					}
				} else {
					accordionSummary.classList.add('ui-accordion-header-active');
          accordion.setAttribute('aria-expanded', "true");
          accordionDetails.setAttribute('aria-hidden', "false");
        }
			}
		}, 20);
	}
}

/**
 * @todo Add handlers for mousedown and enter like the ones above. Do it elegantly.
 */
window.maAccordionDetails = {
  details: document.querySelectorAll('.js-accordion-details'),
  detailsHandler: function() {
    window.maAccordionDetails.details.forEach(detail => detail.addEventListener('click', window.maAccordionDetails.detailToggle));
    window.maAccordionDetails.details.forEach(detail => detail.addEventListener('keydown', window.maAccordionDetails.detailToggle));
  },
  detailToggle:  function(e) {
    const classList = e.target.classList;
    // Special situation for keydown.
    if (e.type == 'keydown') {
      const keyName = e.key;
      // Only fire on blank and enter keypresses.
      if (!(keyName === ' ' || keyName === 'Enter')) {
        return;
      }
    }

    // Prevent the toggle on links within the accordion.
    if (!(classList.contains('js-views-accordion-title') || classList.contains('js-views-accordion-group-header'))) {
      console.log(classList)
      return;
    }
    // Perform the attribute changes to open and close the accordion.
    if (this.hasAttribute('open')) {
      // Already open, close.
      this.removeAttribute('open');
      this.setAttribute('aria-expanded', false);
    } else {
      // First, close all open items
      window.maAccordionDetails.details.forEach((item) => {
        item.removeAttribute('open');
        item.setAttribute('aria-expanded', false);
      });
      // Already closed, open.
      this.setAttribute('open', "");
      this.setAttribute('aria-expanded', true);
    }
  }
}

// if (document.readyState === 'loading') {  // Loading hasn't finished yet
//   document.addEventListener('DOMContentLoaded', window.maAccordionDetails.detailsHandler);
// } else {  // `DOMContentLoaded` has already fired
//   window.maAccordionDetails.detailsHandler();
// }
